import { useTranslation } from "react-i18next";

type RoleData = {
  product: string;
  role: string;
};

type UseMyLeaveRoleTabsParams = {
  rolesData?: RoleData[];
  currentRole?: string;
};

export const useMyLeaveRoleTabs = ({
  rolesData,
  currentRole,
}: UseMyLeaveRoleTabsParams) => {
  const { t } = useTranslation();

  const roles = [
    { key: "examiner", label: t("MY_LEAVE_EXAMINERS_CONTROL_PANEL") },
    { key: "assigner", label: t("MY_LEAVE_ASSIGNER_CONTROL_PANEL") },
    { key: "viewer", label: t("MY_LEAVE_VIEWERS_CONTROL_PANEL") },
  ].filter((role) =>
    rolesData?.some(
      (item) => item.product === "MyLeave" && item.role === role.key,
    ),
  );

  const selectedTab = currentRole ? roles.findIndex((r) => r.key === currentRole) : 0;

  return {
    roles,
    selectedTab,
  };
};

export default useMyLeaveRoleTabs;
